export default __webpack_public_path__ + "static/media/Q6-1.aa9ed075.jpg";